<button
    cmpsButton
    [disabled]="_recording || _uploading"
    (click)="_onRecordClick()"
>
    <span cmpsButtonLabel>Record</span>
</button>

<button
    cmpsButton
    [disabled]="!_recording"
    (click)="_onStopClick()"
>
    <span cmpsButtonLabel>Stop</span>
</button>

<button
    cmpsButton
    [disabled]="!_canSave || _uploading"
    (click)="_onSaveClick()"
>
    <span cmpsButtonLabel>Save</span>
</button>

<ng-container *ngIf="_uploading || _showProgress">
    <div
        [style.width.%]="_progress"
        role="progressbar"
        [attr.aria-valuenow]="_progress * 100"
        aria-valuemin="0"
        aria-valuemax="100"
    >
        {{ _progress | cmpsPercent }}
    </div>
</ng-container>
